import {HttpClient} from "@angular/common/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {TranslateService} from "@ngx-translate/core";
import {Location} from "@angular/common";
import {LocalizeRouterSettings, ManualParserLoader} from "@gilsdav/ngx-translate-router";
import {CustomTranslateLoader} from "../shared/translation/CustomTranslateLoader";

/** BCP 47 / JSON filenames under `assets/i18n/{lang}.json` — lowercase for ngx-translate. */
export enum TranslatorLanguage {
  FR = "fr",
  EN = "en",
  //HI = "hi",
}

export const TRANSLATOR_LANGUAGES = [
  TranslatorLanguage.FR, TranslatorLanguage.EN
]

export const TRANSLATOR_LANGUAGES_DATA = [
  {
    code: TranslatorLanguage.FR,
    name: 'LANG_FRENCH',
    short: "FR"
  },
  {
    code: TranslatorLanguage.EN,
    name: 'LANG_ENGLISH',
    short: "EN"
  },
  /*{
    code: TranslatorLanguage.HI,
    name: 'LANG_INDIA',
    short: "HI"
  },*/
]

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}

export function createCustomTranslateLoader(http: HttpClient) {
  return new CustomTranslateLoader(http);
}

export function createLocalizeRouterTranslateLoader(translate: TranslateService, location: Location, settings: LocalizeRouterSettings) {
  return new ManualParserLoader(
    translate,
    location,
    settings,
    TRANSLATOR_LANGUAGES.map((l) => l as string),
    'ROUTES.',
  );
}
